import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {ProductosVinculacionesMinimoTiposPersonas} from '../_models/productos-vinculaciones-minimo-tipos-personas';


@Injectable({
  providedIn: 'root'
})
export class ProductosVinculacionesMinimoTiposPersonasService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosVinculacionesMinimoTiposPersonas';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductosVinculacionesMinimoTiposPersonas[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductosVinculacionesMinimoTiposPersonas[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductosVinculacionesMinimoTiposPersonas ) );
  }

  listadoPorIdProductoVinculacionMinimo( id: string ) {
    return this.httClient.get( this.rutServicio + '/idProductoVinculacionMinimo/' + id ).pipe( map( res => res as ProductosVinculacionesMinimoTiposPersonas[] ) );
  }

  crear( regCrear: ProductosVinculacionesMinimoTiposPersonas ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductosVinculacionesMinimoTiposPersonas ) );
  }

  actualizar( regActualizar: ProductosVinculacionesMinimoTiposPersonas ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as ProductosVinculacionesMinimoTiposPersonas ) );
  }

  bulk( registros: ProductosVinculacionesMinimoTiposPersonas[] ) {
    registros.forEach( e => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( `${ this.rutServicio }/bulk`, registros ).pipe( map( res => res as ProductosVinculacionesMinimoTiposPersonas[] ) );
  }
}
